module.exports = __webpack_public_path__ + "static/media/check.4e0c0107.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/check.svg
// module id = 80
// module chunks = 0